import Spinner from '@ui/Spinner';
import apolloWrapper from '@hoc/apolloWrapper';
import { ProductCharacteristicsFilter, Option } from '@components/ProductCharacteristicsFilter';
import { logger } from '@utils/logger';

import { useProductCharacteristicsFilterQuery } from './gql/graphql.v3.generated';

import s from './ProductCharacteristicsFilter.sss';

type Props = {
  catalogSlug: string;
  value: number[];
  onCharacteristicChoiceSelect: (choiceId: number) => void;
};

export const ProductCharacteristicsFilterContainer: React.FC<Props> = ({
  catalogSlug,
  value,
  onCharacteristicChoiceSelect,
}) => {
  const { data, loading } = useProductCharacteristicsFilterQuery({
    variables: { catalogSlug },
    context: { batch: true },
  });

  const onSelectItem = (characteristic: Option) => {
    onCharacteristicChoiceSelect(characteristic.id);
  };

  if (loading) {
    return <Spinner />;
  }

  const characteristics = data?.catalog?.characteristics;

  if (!characteristics) {
    logger.error('Empty render');
    return null;
  }

  return (
    <>
      {characteristics.map((characteristic) => (
        <ProductCharacteristicsFilter
          onChange={onSelectItem}
          value={value}
          key={characteristic.id}
          title={characteristic.title}
          items={characteristic.choices}
          className={s.filter}
        />
      ))}
    </>
  );
};

export default apolloWrapper(ProductCharacteristicsFilterContainer);
